function toggleDropdown(event) {
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }

    var dropdown = document.getElementById("flagDropdown");
    if (!dropdown) return;

    dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
}

// Cookie helpers
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
    var nameEq = name + "=";
    var parts = document.cookie.split(";");

    for (var i = 0; i < parts.length; i++) {
        var c = parts[i].trim();
        if (c.indexOf(nameEq) === 0) {
            return decodeURIComponent(c.substring(nameEq.length));
        }
    }

    return null;
}

// UI helpers
function setSelectedFlagUI(flagTitle, flagImage) {
    var img = document.getElementById("selected-flag");
    var txt = document.getElementById("selected-text");

    if (img && flagImage) {
        img.src = flagImage;
    }

    if (txt && flagTitle) {
        txt.textContent = flagTitle;
    }
}

function getCurrentHomePageKeyFromDom() {
    var el = document.getElementById("currentHomePageKey");
    if (!el) return null;

    var val = (el.value || "").trim();
    return val.length ? val : null;
}

function mapFlagBySiteKey(siteKey) {
    if (!siteKey) return null;

    if (siteKey === "aa7eee80-35b3-407a-bfb0-1a5842123d6f") {
        return {
            title: "AU",
            image: "/Frontend/Images/au-flag.svg"
        };
    }

    if (siteKey === "c3e6e14b-ffcc-479e-a208-fadfaf7e2fd5") {
        return {
            title: "USA",
            image: "/Frontend/Images/usa-flag.svg"
        };
    }

    return null;
}

function applySelectedFlagFromCurrentHomePageKeyOrCookie() {
    // Prefer current page key
    var currentKey = getCurrentHomePageKeyFromDom();
    if (currentKey) {
        var mapped = mapFlagBySiteKey(currentKey);
        if (mapped) {
            setSelectedFlagUI(mapped.title, mapped.image);

            setCookie("selectedSiteKey", currentKey, 365);
            setCookie("selectedFlagTitle", mapped.title, 365);
            setCookie("selectedFlagImage", mapped.image, 365);

            return;
        }
    }

    // Fall back to cookie
    var flagTitle = getCookie("selectedFlagTitle");
    var flagImage = getCookie("selectedFlagImage");

    if (flagTitle && flagImage) {
        setSelectedFlagUI(flagTitle, flagImage);
    }
}

function selectFlag(siteKey, siteUrl, flagTitle, flagImage) {
    if (siteKey) setCookie("selectedSiteKey", siteKey, 365);
    if (flagTitle) setCookie("selectedFlagTitle", flagTitle, 365);
    if (flagImage) setCookie("selectedFlagImage", flagImage, 365);
    if (siteUrl) setCookie("selectedSiteUrl", siteUrl, 365);

    setSelectedFlagUI(flagTitle, flagImage);

    var dropdown = document.getElementById("flagDropdown");
    if (dropdown) {
        dropdown.style.display = "none";
    }

    if (siteUrl) {
        window.location.href = siteUrl;
    }
}

document.addEventListener("click", function (e) {
    if (!e.target.closest(".flag-select")) {
        var dropdown = document.getElementById("flagDropdown");
        if (dropdown) {
            dropdown.style.display = "none";
        }
    }
});

document.addEventListener("DOMContentLoaded", function () {
    applySelectedFlagFromCurrentHomePageKeyOrCookie();
});